// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 00:06:12

export default {
  "id": "sprunki-find-the-differences",
  "slug": "sprunki-find-the-differences",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/e4dee4d6b31940fc9bc701c5ffa8518f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/e4dee4d6b31940fc9bc701c5ffa8518f/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sprunki Find The Differences",
      "description": "Unleash Your Detective Skills with Sprunki Find The Differences!\nInspired by the charming world of Sprunki, this game takes your observation skills to the next level. Dive into beautifully crafted scenes filled with vibrant details, where your task is to spot the differences between two seemingly identical images.\nWhether you're a fan of Sprunki or just love a good brain teaser, Sprunki Find The Differences offers a perfect mix of challenge and fun for players of all ages",
      "instructions": "Mouse Tap ",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "boys",
        "differences",
        "girls",
        "hidden",
        "timekiller"
      ]
    },
    "zh-CN": {
      "title": "精灵寻不同",
      "description": "释放你的侦探技能，体验Sprunki找不同！\n灵感来源于迷人的Sprunki世界，这款游戏将你的观察能力提升至新高度。深入精美制作的场景，其中充满了鲜艳的细节，你的任务是找出两张看似相同的图像之间的差异。\n无论你是Sprunki的粉丝还是喜欢解决智力谜题，Sprunki找不同为所有年龄段的玩家提供了完美的挑战与乐趣的混合体。",
      "instructions": "鼠标点击",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "男孩们",
        "差异",
        "女孩们",
        "隐藏",
        "时间杀手"
      ]
    },
    "zh-TW": {
      "title": "Sprunki 找不同",
      "description": "釋放您的偵探技能，與Sprunki尋找不同！\n靈感來自迷人的Sprunki世界，這款遊戲將您的觀察力提升至新境界。深入精心打造的場景，充滿生動細節，您的任務是發現兩張看似相同的圖片之間的不同之處。\n無論您是Sprunki的粉絲還是喜歡好玩的腦筋急轉彎，Sprunki尋找不同為所有年齡段的玩家提供了一個挑戰與樂趣並存的完美結合。",
      "instructions": "滑鼠點擊",
      "genres": [
        "休闲",
        "拼圖"
      ],
      "tags": [
        "男孩們",
        "差異",
        "女孩們",
        "隱藏",
        "時間消磨者"
      ]
    },
    "zh-HK": {
      "title": "Sprunki 找不同",
      "description": "解放你的偵探技巧！ Sprunki 找出不同！\n靈感來自迷人的 Sprunki 世紀，這款遊戲將你的觀察技巧提升至另一個境界。深入美麗製作的場景，充滿生動的細節，你的任務是發現兩張看似相同的圖片之間的不同之處。\n無論你是 Sprunki 的粉絲還是只是喜歡好玩的腦力遊戲，Sprunki 找出不同為各年齡層的玩家提供了一個完美的挑戰與樂趣的混合體。",
      "instructions": "鼠標輕點",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "boys",
        "differences",
        "girls",
        "隱藏",
        "時間殺手"
      ]
    },
    "ja": {
      "title": "スプリンキー・ファインド・ザ・ディファレンス",
      "description": "スプリンキーの魅力的な世界にインスパイアされたこのゲームは、あなたの観察力を次のレベルに引き上げます。美しく作られたシーンに飛び込み、鮮やかな詳細に満ちた世界で、看似同一の2枚の画像の違いを見つけるというあなたのタスクに挑戦しましょう。\n\nスプリンキーのファンであればあるし、ただ頭を働かせるのが好きな人でも、どんな年代のプレイヤーにも楽しめるチャレンジと楽しみが詰まったスプリンキー・ファインド・ザ・ディファレンスを提供します。",
      "instructions": "マウスタップ",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "ボーイズ",
        "違い",
        "ガールズ",
        "隠された",
        "タイムキラー"
      ]
    },
    "ko": {
      "title": "스프랑키 차이점 찾기",
      "description": "스프런키 탐정 기술을 발휘하여 '스프런키 차이 찾기'를 즐겨보세요!\n스프런키의 매력적인 세계를 영감으로 받은 이 게임은 당신의 관찰력을 한 단계 더 높여줍니다. 아름다운 장면들로 가득한 생동감 넘치는 세계로 뛰어들어, 두 가지 모두 같은 것처럼 보이는 이미지 사이의 차이를 찾아보세요.\n스프런키 팬이든, 좋은 뇌 맞추기 게임을 사랑하는 사람이든, 스프런키 차이 찾기는 모든 연령대의 플레이어에게 도전과 즐거움을 제공하는 완벽한 조합을 제공합니다.",
      "instructions": "마우스 탭",
      "genres": [
        "캐주얼",
        "패uzzle"
      ],
      "tags": [
        "아이들",
        "차이",
        "소녀들",
        "숨겨져 있음",
        "시간쉬기"
      ]
    },
    "fr": {
      "title": "Sprunki Trouver les Différences",
      "description": "Libérez vos compétences de détective avec Sprunki Find The Differences !\nInspiré du charmant monde de Sprunki, ce jeu élève votre agilité visuelle au prochain niveau. Plongez dans des scènes magnifiquement conçues remplies de détails vibrants, où votre tâche consiste à repérer les différences entre deux images apparemment identiques.\nQue vous soyez fan de Sprunki ou simplement amateur de bonne énigme, Sprunki Find The Differences offre un mélange parfait de défi et de plaisir pour les joueurs de tous âges.",
      "instructions": "Clic souris",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "garçons",
        "différences",
        "filles",
        "cachés",
        "timekiller"
      ]
    }
  }
};
